// types

import { createSelector } from 'reselect';

// @see:https://github.com/reduxjs/reselect#reselect
const archivesSelector: Selector<
  RootState,
  DomainEntity<Archive> | undefined
> = (state: RootState) => state.domain.archives;

export const sortByReleaseAtSelector = createSelector<
  RootState,
  DomainEntity<Archive> | undefined,
  any
>([archivesSelector], (archives): any => {
  const grouped: GroupedArchive = {};
  if (archives === undefined) return null;

  const dumbArray: Array<Archive> = [];

  // group by releaseAt order by releaseAt desc, id desc
  for (const id of archives.allIds) {
    const archive: Archive = archives.byId[`${id}`];
    dumbArray.push(archive);
  }

  const sortdData = dumbArray.sort((a, b) => {
    return new Date(b.releaseAt).valueOf() - new Date(a.releaseAt).valueOf();
  });

  const groupNames = Array.from(new Set(sortdData.map((k) => k.releaseAt)));

  groupNames.forEach((k) => {
    const date = new Date(k).toLocaleDateString();
    grouped[date] = [];
  });

  sortdData.forEach((k) => {
    const date = new Date(k.releaseAt).toLocaleDateString();
    grouped[date].push(k);
  });

  return grouped;
});
export type GroupedArchive = {
  [key: string]: Archive[];
};

import type { Selector } from 'reselect';
import type { RootState, DomainEntity } from '@/store/index';
import type Archive from '@/domain/archives/index';
